import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { TuiButtonModule } from '@taiga-ui/core';
import { GoogleAuthService } from '@shared/services/google-auth.service';

@Component({
  selector: 'app-sign-in-with-google',
  standalone: true,
  imports: [TranslocoPipe, TuiButtonModule],
  templateUrl: './sign-in-with-google.component.html',
  styleUrl: './sign-in-with-google.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInWithGoogleComponent {
  constructor(private readonly googleAuthService: GoogleAuthService) {}

  signInWithGoogle() {
    this.googleAuthService.signIn();
  }
}
